import React, { useEffect, useRef, useState } from "react";
import { FormButton } from "components";
import { FormikSelectInput, FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { SFHabitacionGet } from "services/services-mia/SFHabitacionGet";
import { SFHabitacionUpd } from "services/services-mia/SFHabitacionUpd";
import { SFUsuarioHotelGet } from "services/services-mia/SFUsuarioHotelGet";
import { GENERO_OPTIONS, STATUS_OPTIONS } from "consts/hotel";

export default function UpdateModal({ updateList, user, closeModal }) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const formikRef = useRef();
    const [inRequest, setInRequest] = useState(false);
    const [hoteles, setHoteles] = useState([]);

    useEffect(() => {
        (async () => {
            const hotelesResult = await SFUsuarioHotelGet(credentials);
            if (Array.isArray(hotelesResult) && hotelesResult[0]?.SFHotelId) {
                setHoteles(hotelesResult);
            }

            const result = await SFHabitacionGet(credentials, { SFHabitacionId: user.id });
            const habitacion = result?.[0];
            if (!habitacion?.SFHabitacionId) return;

            formikRef.current.setValues({
                hotelId: habitacion.SFHotelId,
                numero: habitacion.SFHabitacionNumero,
                piso: habitacion.SFHabitacionPiso,
                plazas: habitacion.SFHabitacionPlazas,
                genero: habitacion.SFHabitacionGenero,
                status: habitacion.SFHabitacionStatus,
                version: habitacion.SFHabitacionVersion,
            });
        })();
    }, [credentials, user.id]);

    const handleSubmit = async (values) => {
        setInRequest(true);
        const response = await SFHabitacionUpd(credentials, {
            SFHabitacionId: user.id,
            SFHotelId: Number(values.hotelId),
            SFHabitacionNumero: values.numero,
            SFHabitacionPiso: values.piso,
            SFHabitacionPlazas: values.plazas,
            SFHabitacionStatus: values.status,
            SFHabitacionGenero: values.genero,
            SFHabitacionVersion: values.version,
        });
        setInRequest(false);
        if (response.length === 0) {
            setSnackBarInfo({
                message: "Habitación modificada correctamente",
                severity: "success",
                open: true,
            });
            formikRef.current.resetForm();
            updateList();
            closeModal();
        }
    };

    return (
        <Formik
            innerRef={formikRef}
            initialValues={{
                hotelId: "",
                numero: "",
                piso: "",
                plazas: "",
                genero: "",
                status: "",
                version: "",
            }}
            validationSchema={yup.object({
                hotelId: yup.number().required("Debe seleccionar un hotel"),
                numero: yup.string().required("Debe ingresar el número"),
                piso: yup.string().required("Debe ingresar el piso"),
                plazas: yup.string().required("Debe ingresar las plazas"),
                genero: yup.string().required("Debe seleccionar el género"),
                status: yup.string().length(1).required("Debe seleccionar el estado"),
                version: yup.number()
            })}
            onSubmit={handleSubmit}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column-2"]}>
                    <div className={styles["span-2"]}>
                        <FormikSelectInput name="hotelId" labelText="Hotel" disabled={true}>
                            <option value="" >Seleccionar hotel</option>
                            {hoteles.map((hotel) => (
                                <option key={hotel.SFHotelId} value={hotel.SFHotelId}>
                                    {hotel.SFHotelNombre}
                                </option>
                            ))}
                        </FormikSelectInput>
                    </div>
                    <FormikTextInput name="numero" labelText="Número" />
                    <FormikTextInput name="piso" labelText="Piso" />
                    <FormikTextInput name="plazas" labelText="Plazas" />
                    <FormikSelectInput name="genero" labelText="Género">
                        <option value="">Seleccionar género</option>
                        {GENERO_OPTIONS.map(({ value, label }) => (
                            <option key={value} value={value}>
                                {label}
                            </option>
                        ))}
                    </FormikSelectInput>
                    <FormikSelectInput name="status" labelText="Estado">
                        <option value="">Seleccionar estado</option>
                        {STATUS_OPTIONS.map(({ value, label }) => (
                            <option key={value} value={value}>
                                {label}
                            </option>
                        ))}
                    </FormikSelectInput>
                    <div className={styles.actions}>
                        <FormButton
                            inRequest={inRequest}
                            newFormData={{ button: "Modificar" }}
                            onCloseModal={closeModal}
                        />
                    </div>
                </div>
            </Form>
        </Formik>
    );
}
